'use strict';

var FilterServiceGridFilterFactory = function FilterServiceGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLevelFilterFactory', 'FlightCabinFilterFactory', 'FlightLegFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FilterServiceGridFilter() {
    DemandFilter.call(this, ['cabin', 'booking-matrix'], ['service-flight-analysis', 'service-demand-analysis-booking-matrix']);
    this.registerFilters(injectedFilters);
  }
  FilterServiceGridFilter.constructor = FilterServiceGridFilter;
  FilterServiceGridFilter.prototype = Object.create(DemandFilter.prototype);
  FilterServiceGridFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return FilterServiceGridFilter;
};
FilterServiceGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FilterServiceGridFilterFactory;